export default __webpack_public_path__ + "static/media/FoundersGrotesk-RegularItalic.f3c4819a.ttf";